document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-list__list-item').forEach(item => {
    const details = item.querySelector('details');
    if (!details) return;
    
    item.addEventListener('mouseenter', e => e.stopImmediatePropagation());
    item.addEventListener('mouseleave', e => e.stopImmediatePropagation());
  });
});
